import {Navigate, useSearchParams} from 'react-router'

import {getUrl, PLANT_ROUTES, useUrlParam} from '../routing'

import {useItemDetails} from './providers'

export const DefaultNodeTabRedirect: React.FC = () => {
  const plantCode = useUrlParam('plantCode')
  const nodeId = useUrlParam('nodeId')
  const [searchParams] = useSearchParams()

  const {availableTabs} = useItemDetails()

  if (availableTabs.length > 0) {
    const targetUrl = getUrl(PLANT_ROUTES.PLANT_SETUP.NODE.NODE_TAB.path, {
      plantCode,
      nodeId,
      nodeTab: availableTabs[0].value
    })
    
    const searchParamsString = searchParams.toString()
    const urlWithParams = searchParamsString ? `${targetUrl}?${searchParamsString}` : targetUrl
    
    return (
      <Navigate
        to={urlWithParams}
        replace
      />
    )
  }
  return null
}
